












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LessonsBlock extends Vue {
  @Prop({ type: String, default: '' })
  readonly date!: string;

  @Prop({ type: String, default: '' })
  readonly dateText!: string;

  @Prop({ type: Boolean, default: false })
  readonly isLinks!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isOpenBlock!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/legend/components/lessonsblock/LessonsBlock.vue